import React from "react";

/**
 * Centered card layout shared by the unauthenticated account pages
 * (forgot password, reset password). Always light — these pages render
 * before any tenant theme preference is known.
 */
export function OcAuthPageShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 [color-scheme:light]">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center gap-2.5 mb-3">
            <svg viewBox="0 0 48 54" fill="none" className="w-9 h-9 flex-shrink-0" aria-hidden="true">
              <path
                d="M24 2 L44 10 L44 26 C44 37 34 45 24 50 C14 45 4 37 4 26 L4 10 Z"
                fill="none"
                stroke="#00D4FF"
                strokeWidth="2.5"
              />
              <path
                d="M13 26 L20 33 L35 18"
                stroke="#00D4FF"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="text-left">
              <div className="text-base font-bold text-slate-900 leading-tight">OnboardConnect</div>
              <div className="text-[10px] font-medium text-oc-teal-600 tracking-widest uppercase leading-tight">
                for Slate CRM
              </div>
            </div>
          </div>
          <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
          <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">{children}</div>
      </div>
    </div>
  );
}

export const ocAuthInputCls =
  "w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-oc-teal-500 focus:border-transparent";

export const ocAuthButtonCls =
  "w-full rounded-lg bg-oc-teal-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-oc-teal-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors";
